import { render, staticRenderFns } from "./AgoraVideoCall.vue?vue&type=template&id=80899206&"
import script from "./AgoraVideoCall.vue?vue&type=script&lang=js&"
export * from "./AgoraVideoCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports